import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import './index.css';
import { MemorizedFavBtn } from '../../components/Vendor/FoodItem/ValueItems';
import { toggleProductFavourite } from '../../store/actions/vendors';

const PopularItems = ({ landingPageData }) => {
  const { t } = useTranslation();

  // If we don't have landing page data yet, return null or a loading state
  if (!landingPageData) {
    return null;
  }

  // Use landing page data for title/subtitle
  const title = landingPageData.landingPage?.popularItemsTitle || t('landing.popular_items.title');
  const subtitle =
    landingPageData.landingPage?.popularItemsSubtitle || t('landing.popular_items.subtitle');

  // Default popular items in case landing page doesn't have any
  const defaultPopularProducts = [
    { id: 1, title: 'Kalcone Klasik', price: 450, desc: 'mocarela, proshute, salce' },
    { id: 2, title: 'Kalcone Klasik Plus', price: 550, desc: 'mocarela, proshute, salce' },
    { id: 3, title: 'Kalcone Fiatone', price: 630, desc: 'mocarela, proshute, salce' },
    { id: 4, title: 'Kalcone Raviolone', price: 630, desc: 'mocarela, proshute, salce' },
    { id: 5, title: 'Kalcone Taris', price: 650, desc: 'mocarela, proshute, salce' },
    { id: 6, title: 'Kalcone Farcito', price: 700, desc: 'mocarela, proshute, salce' }
  ];

  // Use landing page items, or fall back to defaults
  const popularItems =
    landingPageData.landingPage?.popularItems?.length > 0
      ? landingPageData.landingPage.popularItems.map((item) => ({
          id: item.id || `lp-${item.title}`,
          title: item.title,
          price: item.price,
          desc: item.description,
          imagePath: item.imagePath
        }))
      : defaultPopularProducts;

  const onPressFav = (item) => {
    toggleProductFavourite(item?.id, item?.isFav === 1 ? 0 : 1)
      .then(() => {
        // Success handling if needed
      })
      .catch(() => {
        // Error handling if needed
      });
  };

  return (
    <div className="popular-items-container">
      <div className="snapfood-title-block">
        <h1>{title}</h1>
        <p>{subtitle}</p>
      </div>

      <div className="popular-items-grid">
        {popularItems.map((item, index) => (
          <div key={index} className="popular-item-card">
            {item.imagePath && (
              <div className="item-image">
                <img src={item.imagePath} alt={item.title} />
              </div>
            )}
            <h3>{item.title}</h3>
            <h5>{item.price} L</h5>
            <p>{item.desc}</p>
            <div className="fav-btn">
              <MemorizedFavBtn item={item} onPress={() => onPressFav(item)} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

PopularItems.propTypes = {
  landingPageData: PropTypes.object
};

export default PopularItems;
